import {
  Flex,
  View,
  ToggleGroup,
  Table,
  IconButton,
  IconToggleEndLine,
  Badge,
  Tooltip,
  IconStandardsLine,
  IconLockLine,
  IconUnlockLine,
} from '@instructure/ui';

import useAppStore from '../../stores/app';

const RoomList = ({ locations, rooms }) => {
  const { setRoomSid } = useAppStore();

  const joinRoom = async (roomSid) => {
    const setRoomResult = await setRoomSid(roomSid);

    if (setRoomResult) {
      window.location = '/rooms/' + roomSid;
    }
  };

  return (
    <View
      as="div"
      justifyContent="center"
      alignItems="center"
      withVisualDebug={false}
      width="100%"
    >
      {locations.map((location) => (
        <ToggleGroup
          as="div"
          width="100%"
          margin="xxx-small none"
          key={`location_${location.proctorAccountLocationSid}`}
          toggleLabel="This is the toggle button label for screenreaders"
          summary={
            <Flex justifyItems="space-between" margin="none small none none">
              <Flex.Item>{location.locationName}</Flex.Item>
              <Flex.Item>
                <Tooltip
                  renderTip={`${location.activeRoomCount} rooms online`}
                  as="span"
                  offsetX={3}
                >
                  <Badge
                    count={location.activeRoomCount}
                    variant="primary"
                    standalone
                    margin="none"
                  />
                </Tooltip>
              </Flex.Item>
            </Flex>
          }
          defaultExpanded={locations.length === 1 ? true : false}
          background="default"
        >
          <Table caption="Top rated movies" layout="fixed" hover={true}>
            <Table.Head>
              <Table.Row>
                <Table.ColHeader width="40%" id="Title">
                  Name
                </Table.ColHeader>
                <Table.ColHeader width="18%" id="Year" textAlign="center">
                  Max Capacity
                </Table.ColHeader>
                <Table.ColHeader width="18%" id="Rating" textAlign="center">
                  Sessions
                </Table.ColHeader>
                <Table.ColHeader width="18%" id="Rating" textAlign="center">
                  Proctors
                </Table.ColHeader>
                <Table.ColHeader
                  width="10%"
                  id="Rating"
                  textAlign="center"
                ></Table.ColHeader>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {location.rooms.map((room) => (
                <Table.Row key={`room_${room.sid}`}>
                  <Table.Cell>
                    {room.isShared ? (
                      <View as="span" margin="none x-small none none">
                        <IconUnlockLine />
                      </View>
                    ) : (
                      <View as="span" margin="none x-small none none">
                        <IconLockLine />
                      </View>
                    )}
                    {room.roomName}
                    {room.greeterOnly && (
                      <View as="span" margin="none none none x-small">
                        <IconStandardsLine />
                      </View>
                    )}
                  </Table.Cell>
                  <Table.Cell textAlign="center">{room.maxStudents}</Table.Cell>
                  <Table.Cell textAlign="center">
                    {room.activeSessions}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    {room.proctors.length}
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    <IconButton
                      withBackground={false}
                      withBorder={false}
                      color="primary"
                      size="small"
                      screenReaderLabel={`Join ${room.roomName}`}
                      margin="none"
                      padding="none"
                      onClick={() => joinRoom(room.sid)}
                    >
                      <IconToggleEndLine />
                    </IconButton>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </ToggleGroup>
      ))}
    </View>
  );
};

export default RoomList;
